<template>
  <div class="template-gallery">
    <!-- 头部 -->
    <header class="header">
      <div class="logo">芝麻开花智能写作平台</div>
      <div class="header-actions">
        <el-button @click="goBack" type="primary" plain>
          <el-icon><ArrowLeft /></el-icon>
          返回首页
        </el-button>
      </div>
    </header>

    <!-- 主要内容 -->
    <main class="main-content">
      <div class="gallery-container">
        <!-- 左侧选项卡 -->
        <div class="left-section">
          <div class="tab-container">
            <div class="tab-item active">
              <span class="tab-text">万字论文（截取版）</span>
            </div>
          </div>
        </div>

        <!-- 右侧图片展示 -->
        <div class="right-section">
          <div class="image-gallery">
            <div class="image-item">
              <img src="@/assets/moban/1.jpg" alt="模板1" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/2.jpg" alt="模板2" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/3.jpg" alt="模板3" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/4.jpg" alt="模板4" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/5.jpg" alt="模板5" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/6.jpg" alt="模板6" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/7.jpg" alt="模板7" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/8.jpg" alt="模板8" class="template-image" />
            </div>
            <div class="image-item">
              <img src="@/assets/moban/9.jpg" alt="模板9" class="template-image" />
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ArrowLeft } from '@element-plus/icons-vue'

const router = useRouter()

const goBack = () => {
  router.push('/')
}
</script>

<style scoped>
.template-gallery {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 头部样式 */
.header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.header-actions {
  display: flex;
  gap: 15px;
}

/* 主要内容 */
.main-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
}

.gallery-container {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 40px;
  align-items: start;
}

/* 左侧选项卡区域 */
.left-section {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 100px;
}

.tab-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tab-item {
  padding: 15px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.tab-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.tab-item:hover:not(.active) {
  background: #f8f9fa;
  border-color: #e9ecef;
}

.tab-text {
  font-size: 16px;
  font-weight: 600;
}

/* 右侧图片展示区域 */
.right-section {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.image-gallery {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.image-item {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
}

.image-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.template-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .gallery-container {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .left-section {
    position: static;
  }
}

@media (max-width: 768px) {
  .header {
    padding: 15px 20px;
    flex-direction: column;
    gap: 15px;
  }
  
  .main-content {
    padding: 20px 15px;
  }
  
  .left-section,
  .right-section {
    padding: 25px;
  }
  
  .image-gallery {
    flex-direction: column;
  }
  
  .template-image {
    height: auto;
  }
}
</style>
